export const MenuItems = [
  {
    title: 'Events',
    url: '/openevents',
    cName: 'nav-links',
  },
  {
    title: 'Challenges',
    cName: 'nav-links',
    subMenu: [
      {
        title: 'My Challenges',
        url: '/assignments',
      },
      {
        title: 'Create/Edit Challenge',
        url: '/questions',
      },
      // {
      //   title: 'Premium Challenges',
      //   url: '/premiumevents',
      // },
    ],
  },
  {
    title: 'Practice',
    cName: 'nav-links',
    subMenu: [
      {
        title: 'Regular Practice',
        url: '/practiceevents',
      },
      {
        title: 'Daily SpellBowl Review',
        url: '/dailyreview'
      },
    ],
  },
  {
    title: 'Batches',
    url: '/batch',
    cName: 'nav-links',
  },
  {
    title: 'Courses',
    url: '/opencourses',
    cName: 'nav-links',
  },
  // {
  //   title: 'Premium',
  //   url: '/premiumevents',
  //   cName: 'nav-links',
  // },

];
